<template>
  <div class="caddy-profile-page">
    <div id="list" v-if="viewType == 'list'">
      <div class="row center-block">
        <div class="col-md-12">
          <div class="box caddy-box">
            <div class="box-header caddy-box-header">
              <label for="recordPerPage" class="col-sm-1 col-md-1 col-lg-1 caddy-show-label">Show</label>
              <div class="col-sm-2 col-md-2 col-lg-1 caddy-page-size-wrap">
                <select v-on:change="changePageSize" ref="recordPerPage" class="form-control caddy-form-control">
                  <option v-if="inquiryParam.pageSize == 5" selected>5</option><option v-else>5</option>
                  <option v-if="inquiryParam.pageSize == 10" selected>10</option><option v-else>10</option>
                  <option v-if="inquiryParam.pageSize == 20" selected>20</option><option v-else>20</option>
                  <option v-if="inquiryParam.pageSize == 50" selected>50</option><option v-else>50</option>
                  <option v-if="inquiryParam.pageSize == 100" selected>100</option><option v-else>100</option>
                </select>
              </div>
              <div class="box-tools caddy-tools">
                <button v-on:click="onCreate" class="btn btn-primary caddy-btn-primary">Create</button>
                <button v-on:click="inquiry" class="btn btn-warning caddy-btn-warning">Search</button>
              </div>
            </div>

            <div class="box-body no-padding table-responsive caddy-table-wrap">
              <table class="table table-striped caddy-table">
                <thead>
                  <tr>
                    <th style="width: 45px;text-align:center;">#</th>
                    <th style="text-align:left;">Action</th>
                    <th style="text-align:left;">Caddy Name</th>
                    <th style="text-align:left;">status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, i) in listData" v-bind:key="i">
                    <td style="width:45px;text-align:center;">{{ startSequence + i + 1}}</td>
                    <td style="width:85px;text-align:left;">
                      <a href="#" v-on:click="onDisplay(row)" ref="displayRow" style="padding-right:5px">
                        <span class="icon ion-search" data-toggle="tooltip" data-placement="right" title="Display"></span>
                      </a>
                      <a href="#" v-on:click="onEdit(row)" ref="editRow" style="padding-right:5px">
                        <span class="icon ion-edit" data-toggle="tooltip" data-placement="right" title="Edit"></span>
                      </a>
                      <a href="#" v-on:click="onDelete(row)" ref="deleteRow" style="padding-right:5px">
                        <span class="icon ion-ios-trash" data-toggle="tooltip" data-placement="right" title="Delete"></span>
                      </a>
                    </td>
                    <td>{{ row.fullName }}</td>
                    <td>{{ row.status }}</td>
                    <td hidden>{{ row.id }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="box-footer caddy-box-footer">
              <div class="form-group">
                <label style="width:25px;text-align:right;">
                  <a href="#"><i v-on:click="changePage(1)" class="icon ion-ios-rewind"></i></a>
                </label>
                <label style="width:35px;text-align:center;">
                  <a href="#"><i v-on:click="changePage(inquiryParam.CurrentPageNumber - 1)" class="icon ion-arrow-left-b"></i></a>
                </label>
                <label>Page</label>
                <label>
                  <input v-model="inquiryParam.CurrentPageNumber" v-on:keyup.enter="gotoPage($event)" type="text" class="form-control caddy-form-control" id="CurrentPage" style="width:50px;margin-left:5px;margin-right:5px;">
                </label>
                <label id="TotalPageText">{{ totalPages }}</label>
                <label style="width:35px;text-align:center;">
                  <a href="#"><i v-on:click="changePage(inquiryParam.CurrentPageNumber + 1)" class="icon ion-arrow-right-b"></i></a>
                </label>
                <label style="width:25px;text-align:left;">
                  <a href="#"><i v-on:click="changePage(totalPages)" class="icon ion-ios-fastforward"></i></a>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <transition name="fade">
      <div id="form" v-if="viewType == 'form'">
        <div class="row center-block">
          <div class="col-md-12">
            <div class="box box-info caddy-box">
              <form @submit.prevent class="form-horizontal caddy-form">
                <div class="box-body caddy-box-body">
                  <div class="row">
                    <div class="col-md-8">
                      <div class="form-group caddy-form-group">
                        <label class="col-sm-2 control-label caddy-control-label">
                          Caddy ID
                        </label>
                        <div class="col-sm-10">
                          <input :disabled="viewMode == MODE_VIEW" type="text" class="form-control caddy-form-control" placeholder="Caddy ID" v-model="formData.caddyCode">
                        </div>
                      </div>

                      <div class="clearfix"></div>

                      <div class="form-group caddy-form-group">
                        <label class="col-sm-2 control-label caddy-control-label">
                          Caddy Name
                        </label>
                        <div class="col-sm-10 caddy-name-wrap">
                          <input :disabled="viewMode == MODE_VIEW" type="text" class="form-control caddy-form-control caddy-first-name" placeholder="First Name" v-model="formData.firstName">
                          <input :disabled="viewMode == MODE_VIEW" type="text" class="form-control caddy-form-control caddy-last-name" placeholder="Last Name" v-model="formData.lastName">
                        </div>
                      </div>

                      <div class="clearfix"></div>

                      <div class="form-group caddy-form-group">
                        <label class="col-sm-2 control-label caddy-control-label">
                          Caddy Short Name
                        </label>
                        <div class="col-sm-10">
                          <input :disabled="viewMode == MODE_VIEW" class="form-control caddy-form-control" placeholder="Full Name" v-model="formData.nickname">
                        </div>
                      </div>

                      <div class="form-group caddy-form-group">
                        <label class="col-sm-2 control-label caddy-control-label">
                          Gender
                        </label>
                        <div class="col-sm-10">
                          <input :disabled="viewMode == MODE_VIEW" class="form-control caddy-form-control" placeholder="Gender" v-model="formData.gender">
                        </div>
                      </div>

                      <div class="clearfix"></div>

                      <div class="form-group caddy-form-group">
                        <label class="col-sm-2 control-label caddy-control-label">
                          Working Type
                        </label>
                        <div class="col-sm-10">
                          <select :disabled="viewMode == MODE_VIEW" class="form-control caddy-form-control" v-model="formData.workingType">
                            <option value="">-- Select Working --</option>
                            <option value="Captain">Permanent</option>
                            <option value="Senior Caddy">Kontrak</option>
                            <option value="Junior Caddy">Intern</option>
                          </select>
                        </div>
                      </div>

                      <div class="clearfix"></div>

                      <div class="form-group caddy-form-group">
                        <div class="col-sm-6 caddy-half-col">
                          <label class="col-sm-4 control-label caddy-control-label">
                            Start Date
                          </label>
                          <div class="col-sm-8">
                            <input :disabled="viewMode == MODE_VIEW" type="date" class="form-control caddy-form-control" v-model="formData.joinDate">
                          </div>
                        </div>

                        <div class="col-sm-6 caddy-half-col">
                          <label class="col-sm-4 control-label caddy-control-label">
                            End Date
                          </label>
                          <div class="col-sm-8">
                            <input :disabled="viewMode == MODE_VIEW" type="date" class="form-control caddy-form-control" v-model="formData.resignDate">
                          </div>
                        </div>
                      </div>

                      <div class="clearfix"></div>

                      <div class="form-group caddy-form-group caddy-status-row">
                        <label for="inputStatusCaddy" class="col-sm-2 control-label caddy-control-label">Status</label>
                        <label class="radio-inline caddy-radio-inline">
                          <input :disabled="viewMode == MODE_VIEW" type="radio" value="Active" v-model="formData.status"> Active
                        </label>
                        <label class="radio-inline caddy-radio-inline">
                          <input :disabled="viewMode == MODE_VIEW" type="radio" value="Inactive" v-model="formData.status"> Inactive
                        </label>
                      </div>

                      <div class="clearfix"></div>

                      <div class="form-group caddy-form-group">
                        <div class="col-sm-6 caddy-half-col">
                          <label class="col-sm-4 control-label caddy-control-label">
                            Identity Type
                          </label>
                          <div class="col-sm-8">
                            <select :disabled="viewMode == MODE_VIEW" class="form-control caddy-form-control" v-model="formData.identityType">
                              <option value="">-- Select Identity Type --</option>
                              <option value="KTP">KTP</option>
                              <option value="Passport">Passport</option>
                              <option value="SIM">SIM</option>
                            </select>
                          </div>
                        </div>

                        <div class="col-sm-6 caddy-half-col">
                          <label class="col-sm-4 control-label caddy-control-label">
                            Identity ID
                          </label>
                          <div class="col-sm-8">
                            <input :disabled="viewMode == MODE_VIEW" type="text" class="form-control caddy-form-control" v-model="formData.identityId">
                          </div>
                        </div>
                      </div>

                      <div class="clearfix"></div>

                      <div class="form-group caddy-form-group">
                        <label class="col-sm-2 control-label caddy-control-label">
                          Address
                        </label>
                        <div class="col-sm-8">
                          <textarea :disabled="viewMode == MODE_VIEW" class="form-control caddy-form-control caddy-textarea" rows="3" placeholder="Address" v-model="formData.address"></textarea>
                        </div>
                      </div>

                      <div class="clearfix"></div>

                      <div class="form-group caddy-form-group">
                        <label class="col-sm-2 control-label caddy-control-label">
                          City
                        </label>
                        <div class="col-sm-10">
                          <input :disabled="viewMode == MODE_VIEW" class="form-control caddy-form-control" placeholder="City" v-model="formData.city">
                        </div>
                      </div>

                      <div class="clearfix"></div>

                      <div class="form-group caddy-form-group">
                        <label class="col-sm-2 control-label caddy-control-label">
                          Country
                        </label>
                        <div class="col-sm-10">
                          <input :disabled="viewMode == MODE_VIEW" class="form-control caddy-form-control" placeholder="Country" v-model="formData.country">
                        </div>
                      </div>

                      <div class="clearfix"></div>

                      <div class="form-group caddy-form-group">
                        <div class="col-sm-6 caddy-half-col">
                          <label class="col-sm-4 control-label caddy-control-label">
                            Mobile No 1
                          </label>
                          <div class="col-sm-8">
                            <input :disabled="viewMode == MODE_VIEW" type="number" class="form-control caddy-form-control" v-model="formData.mobilePhone">
                          </div>
                        </div>

                        <div class="col-sm-6 caddy-half-col">
                          <label class="col-sm-4 control-label caddy-control-label">
                            Mobile No 2
                          </label>
                          <div class="col-sm-8">
                            <input :disabled="viewMode == MODE_VIEW" type="number" class="form-control caddy-form-control" v-model="formData.phone">
                          </div>
                        </div>
                      </div>

                      <div class="clearfix"></div>

                      <div class="form-group caddy-form-group">
                        <div class="col-sm-6 caddy-half-col">
                          <label class="col-sm-4 control-label caddy-control-label">
                            Update By
                          </label>
                          <div class="col-sm-8">
                            <input :disabled="viewMode == MODE_VIEW" class="form-control caddy-form-control" v-model="formData.updatedAt">
                          </div>
                        </div>

                        <div class="col-sm-6 caddy-half-col">
                          <div class="col-sm-8">
                            <input :disabled="viewMode == MODE_VIEW" class="form-control caddy-form-control" v-model="formData.updatedBy">
                          </div>
                        </div>
                      </div>

                      <div class="clearfix"></div>

                      <div class="form-group caddy-form-group">
                        <div class="col-sm-6 caddy-half-col">
                          <label class="col-sm-4 control-label caddy-control-label">
                            Create By
                          </label>
                          <div class="col-sm-8">
                            <input :disabled="viewMode == MODE_VIEW" class="form-control caddy-form-control" v-model="formData.createdAt">
                          </div>
                        </div>

                        <div class="col-sm-6 caddy-half-col">
                          <div class="col-sm-8">
                            <input :disabled="viewMode == MODE_VIEW" class="form-control caddy-form-control" v-model="formData.createdBy">
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-4">
                      <div class="caddy-photo-box">
                        <img :src="formData.photoUrl || 'https://placehold.co/170x220?text=Photo'" class="img-responsive center-block">
                        <br>
                        <button class="btn btn-default btn-block caddy-photo-btn">Take Picture</button>
                        <button class="btn btn-default btn-block caddy-photo-btn">Upload Picture</button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="box-footer caddy-box-footer">
                  <div class="box-tools caddy-tools caddy-form-tools">
                    <button @click="onBack()" class="btn btn-default caddy-btn-light" style="margin-right:15px;">Back</button>
                    <button @click="onCancel()" class="btn btn-warning caddy-btn-warning">Cancel</button>
                    <button v-if="viewMode != MODE_VIEW" @click="onSave()" class="btn btn-info pull-right caddy-btn-primary">Save</button>
                    <button v-if="viewMode == MODE_VIEW" @click="onEdit(formData)" class="btn btn-info pull-right caddy-btn-primary">Edit</button>
                    <button v-if="viewMode == MODE_VIEW" @click="onCreate()" class="btn btn-info pull-right caddy-btn-primary" style="margin-right:15px;">Create</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import api from '../../../api'
import SweetAlert from 'sweetalert2'

const VIEW_LIST = 'list'
const VIEW_FORM = 'form'
const MODE_NONE = 'none'
const MODE_CREATE = 'create'
const MODE_VIEW = 'read'
const MODE_UPDATE = 'update'

export default {
  name: 'ProfileCaddy',
  data() {
    return {
      VIEW_LIST: VIEW_LIST,
      VIEW_FORM: VIEW_FORM,
      MODE_NONE: MODE_NONE,
      MODE_VIEW: MODE_VIEW,
      MODE_UPDATE: MODE_UPDATE,
      column: '',
      item: null,
      listData: null,
      totalRows: 0,
      totalPages: 0,
      startSequence: 0,
      inquiryParam: {
        WhereClause: '',
        CurrentPageNumber: 1,
        PageSize: 10,
        SortDirection: 'ASC',
        SortExpression: 'Name'
      },
      viewType: VIEW_LIST,
      viewMode: MODE_NONE,
      formData: {
        id: 0,
        caddyCode: '',
        caddyNumber: '',
        firstName: '',
        lastName: '',
        fullName: '',
        nickname: '',
        gender: '',
        status: 'Active',
        caddyGrade: '',
        joinDate: '',
        resignDate: '',
        phone: '',
        mobilePhone: '',
        email: '',
        address: '',
        city: '',
        photoUrl: '',
        createdBy: '',
        createdAt: '',
        updatedBy: '',
        updatedAt: ''
      }
    }
  },
  created() {
    this.viewType = VIEW_LIST
    this.inquiry()
  },
  mounted() {
    this.$refs.recordPerPage.value = this.inquiryParam.PageSize
  },
  methods: {
    changePageSize(evt) {
      this.inquiryParam.PageSize = evt.target.value
      this.inquiryParam.CurrentPageNumber = 1
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    gotoPage(evt) {
      if (evt.target.value > this.totalPages) {
        this.inquiryParam.CurrentPageNumber = this.totalPages
      } else if (evt.target.value < 1) {
        this.inquiryParam.CurrentPageNumber = 1
      }
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    changePage(page) {
      if (page < 1) {
        this.inquiryParam.CurrentPageNumber = 1
      } else if (page > this.totalPages) {
        this.inquiryParam.CurrentPageNumber = this.totalPages
      } else {
        this.inquiryParam.CurrentPageNumber = page
      }
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    inquiry() {
      api
        .request('Golf', 'get', '/api/golf/masters/caddyProfile?limit=' + this.inquiryParam.PageSize + '&page=' + this.inquiryParam.CurrentPageNumber, null)
        .then(response => {
          var data = response.data
          this.listData = data.entity
          this.total = data.totalRows
          this.totalPages = data.totalPages
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    initForm() {
      this.formData.name = ''
    },
    onCreate() {
      this.initForm()
      this.viewType = VIEW_FORM
      this.viewMode = MODE_CREATE
    },
    onDisplay(row) {
      this.viewType = VIEW_FORM
      this.viewMode = MODE_VIEW

      this.formData.id = row.id
      this.formData.name = row.name
    },
    onEdit(data) {
      this.formData.id = data.id
      this.formData.caddyCode = data.caddyCode
      this.formData.caddyNumber = data.caddyNumber
      this.formData.fullName = data.fullName
      this.formData.status = data.status
      this.viewType = VIEW_FORM
      this.viewMode = MODE_UPDATE
    },
    onDelete(data) {
      SweetAlert.fire({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: true,
        showLoaderOnConfirm: true
      })
      .then((result) => {
        if (result.value) {
          var res = this.delete(data)
          SweetAlert.fire('Deleted', res.message, res.status)
        } else if (result.dismiss === SweetAlert.DismissReason.cancel) {
          SweetAlert.fire('Cancelled', 'Your data is still exist', 'info')
        }
      })
    },
    onCancel() {
      this.initForm()
    },
    onBack() {
      this.inquiry()
      this.viewType = VIEW_LIST
    },
    onSave() {
      var data = {
        Id: this.formData.id,
        caddyCode: this.formData.caddyCode,
        caddyNumber: this.formData.caddyNumber,
        fullName: this.formData.fullName,
        Status: this.formData.status
      }

      var status = 'success'
      var message = ''
      var method = ''
      switch (this.viewMode) {
        case MODE_CREATE:
          method = 'Create'
          break
        case MODE_UPDATE:
          method = 'Update'
          break
      }

      api
        .request('Golf', 'post', '/api/golf/masters/caddyProfile' + method, data)
        .then(response => {
          var resData = response.data
          this.formData = resData.entity
          this.total = resData.totalRows

          status = resData.returnStatus ? 'success' : 'error'
          message = resData.returnMessage.join('<br>')
          SweetAlert.fire(status, message, status)

          if (resData.returnStatus) {
            this.onDisplay({id: this.formData.id, name: this.formData.name})
          }
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    delete(data) {
      var status = ''
      var message = ''
      var reqData = {
        Id: data.id,
        Name: data.name
      }
      api.request('Guest', 'post', '/api/MembershipCategory/Delete', reqData)
        .then(response => {
          var resData = response.data
          status = resData.returnStatus ? 'success' : 'error'
          message = resData.returnMessage
          this.inquiry()
        })
        .catch(error => {
          status = 'error'
          message = 'Error happens when call API delete: ' + error.message
        })
      return { status: status, message: message }
    }
  }
}
</script>

<style>
/* Form-only styling */
.caddy-profile-page #form .box.box-info {
  border: 1px solid #bfd0ea;
  background: rgba(255,255,255,0.15);
  box-shadow: none;
  border-radius: 0;
}

.caddy-profile-page #form .box.box-info .box-body {
  background: transparent;
  padding: 14px 12px 0;
}

.caddy-profile-page #form .box.box-info .box-footer {
  background: #e9f0f9;
  border-top: 1px solid #bfd0ea;
  color: #2d405a;
  padding: 12px 14px;
}

.caddy-profile-page #form .form-horizontal {
  width: 100%;
}

.caddy-profile-page #form .form-horizontal .form-group {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 0 0 18px;
  width: 100%;
}

.caddy-profile-page #form .form-horizontal .control-label {
  flex: 0 0 180px;
  width: 180px;
  max-width: 180px;
  text-align: left;
  color: #2d405a;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.3;
  padding-top: 0;
  margin: 0;
}

.caddy-profile-page #form .form-horizontal [class*="col-sm-"] {
  float: none;
  width: auto;
  min-height: 1px;
  padding-left: 0;
  padding-right: 0;
  flex: 1 1 auto;
}

.caddy-profile-page #form .form-horizontal .col-sm-10,
.caddy-profile-page #form .form-horizontal .col-sm-8,
.caddy-profile-page #form .form-horizontal .col-sm-6,
.caddy-profile-page #form .form-horizontal .col-sm-4 {
  position: static;
  display: block;
}

.caddy-profile-page #form .form-horizontal .form-control {
  width: 100%;
  height: 38px;
  border: 1px solid #bfd0ea;
  border-radius: 4px;
  background: #fff;
  color: #2d405a;
  box-shadow: none;
  font-size: 14px;
}

.caddy-profile-page #form .form-horizontal textarea.form-control {
  min-height: 90px;
  resize: vertical;
}

.caddy-profile-page #form .form-horizontal .radio-inline {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #2d405a;
  margin-right: 18px;
}

.caddy-profile-page #form .form-horizontal .radio-inline input {
  width: 18px;
  height: 18px;
  margin: 3;
}

.caddy-profile-page #form .caddy-name-wrap {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
}

.caddy-profile-page #form .caddy-name-wrap .caddy-first-name,
.caddy-profile-page #form .caddy-name-wrap .caddy-last-name {
  flex: 1;
  width: auto;
}

.caddy-profile-page #form .caddy-half-col {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
}

.caddy-profile-page #form .caddy-half-col .control-label {
  flex: 0 0 120px;
  width: 120px;
}

.caddy-profile-page #form .box-tools .btn {
  border: 1px solid #b9c7dc;
  background: #f5f7fb;
  color: #2d405a;
  border-radius: 3px;
  padding: 7px 14px;
  font-size: 12px;
}

.caddy-profile-page #form .box-tools .btn-primary,
.caddy-profile-page #form .box-tools .btn-info {
  background: #dfeaf9;
  border-color: #aac0df;
}

.caddy-profile-page #form .box-tools .btn-warning {
  background: #fff2cc;
  border-color: #e5c76e;
  color: #7d5a00;
}

.caddy-profile-page #form .box-tools .btn-default {
  background: #f5f7fb;
}

.caddy-profile-page #form .box.box-info .box-body .col-md-4 > div {
  border: 1px solid #d5e0f0;
  background: #f8fafd;
  padding: 16px 14px;
  min-height: 360px;
  text-align: center;
}

.caddy-profile-page #form .box.box-info .box-body img {
  max-height: 220px;
  object-fit: cover;
  border: 1px solid #d5e0f0;
  background: #fff;
  margin: 0 auto 12px;
}

.caddy-profile-page #form .box.box-info .box-body .btn.btn-default {
  border: 1px solid #b9c7dc;
  background: #f5f7fb;
  color: #2d405a;
  margin-top: 8px;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// CaddyProfile.vue?1b74d683